// Apolo IDE — Hermes navigation mailbox (P1-E1-T08 fix).
//
// `apolo:hermes:navigate` is a window event, but HermesView mounts
// CONDITIONALLY (only while the hermes tab is active) and attaches its
// listener in a post-mount effect — a raw dispatch fired from another tab
// (e.g. the Command Center's "Ver agents no Hermes") lands in the void and
// the user arrives on the default section. This module is the fix: a
// module-level PENDING slot that survives until the view mounts.
//
// Callers use requestHermesNavigate(detail): it stores the detail AND
// dispatches the window event, so an already-mounted HermesView reacts live
// (and consumes the slot) while an unmounted one picks it up on mount via
// consumePendingNavigate() — which returns-and-clears, so a navigation is
// applied at most once.

let pending = null;

/** Ask the Hermes tab to navigate. detail = { section, runId? }. */
export function requestHermesNavigate(detail) {
  pending = detail || null;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('apolo:hermes:navigate', { detail }));
  }
}

/** Return-and-clear the pending navigation (null when there is none). */
export function consumePendingNavigate() {
  const detail = pending;
  pending = null;
  return detail;
}
